import { OrganizationName } from 'constants/organization/types';
import { useLocation } from 'react-router-dom';

const useAppName = (): OrganizationName | null => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const appName = queryParams.get('app_name');

    if (appName && appName.toUpperCase() in OrganizationName) {
        return appName as OrganizationName;
    }
    return null;
};

export default useAppName;
